module.exports = __webpack_public_path__ + "img/customer-representative.e6cc6f5f.svg";